{
  "search": "Sök",
  "searchWithin": "Sök inom"
}
